// Omnix/client/ui/AudienceRuleBuilder.js
import { ComponentBase } from "../core/ComponentBase.js";

export class AudienceRuleBuilder extends ComponentBase {
    static styles = `
        .rule-builder-container { border: 1px solid var(--bs-border-color); border-radius: var(--bs-border-radius); padding: 1rem; }
        .rule-row { display: flex; gap: 0.5rem; align-items: center; margin-bottom: 0.5rem; }
        .rule-row .form-select, .rule-row .form-control { flex: 1; }
    `;

    constructor(config) {
        super(config);
        this.rules = [];
        this.applyStyles();
    }

    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'rule-builder-container';
            this.container.innerHTML = `
                <div id="rules-list-${this.config.instanceId}"></div>
                <button type="button" class="btn btn-sm btn-outline-secondary"><i class="bi bi-plus"></i> Add Rule</button>
            `;
            this.rulesList = this.container.querySelector(`#rules-list-${this.config.instanceId}`);
            this.container.querySelector('button').addEventListener('click', () => this.addRuleRow());
        }
        this.renderRules();
        return this.container;
    }

    renderRules() {
        this.rulesList.innerHTML = '';
        this.rules.forEach(rule => this.addRuleRow(rule, false));
    }

    addRuleRow(rule = { id: crypto.randomUUID(), field: 'tags', operator: 'contains', value: '' }, dispatchChange = true) {
        const row = document.createElement('div');
        row.className = 'rule-row';
        row.dataset.ruleId = rule.id;
        
        const fieldOptions = [
            { value: 'tags', label: 'Tags' }, { value: 'email', label: 'Email' },
            { value: 'company', label: 'Company' }, { value: 'firstName', label: 'First Name' }
        ].map(o => `<option value="${o.value}" ${rule.field === o.value ? 'selected' : ''}>${o.label}</option>`).join('');

        const operatorOptions = [
            { value: 'contains', label: 'Contains' }, { value: 'not_contains', label: 'Does Not Contain' },
            { value: 'equals', label: 'Equals' }, { value: 'not_equals', label: 'Does Not Equal' },
            { value: 'startsWith', label: 'Starts With' }, { value: 'endsWith', label: 'Ends With' }
        ].map(o => `<option value="${o.value}" ${rule.operator === o.value ? 'selected' : ''}>${o.label}</option>`).join('');

        row.innerHTML = `
            <select class="form-select form-select-sm" data-prop="field">${fieldOptions}</select>
            <select class="form-select form-select-sm" data-prop="operator">${operatorOptions}</select>
            <input type="text" class="form-control form-control-sm" data-prop="value" value="${rule.value}">
            <button type="button" class="btn btn-sm btn-outline-danger"><i class="bi bi-trash"></i></button>
        `;

        row.querySelector('button').addEventListener('click', () => {
            row.remove();
            this.container.dispatchEvent(new Event('change', { bubbles: true }));
        });

        this.rulesList.appendChild(row);
        if (dispatchChange) {
            this.container.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    getValue() {
        return Array.from(this.rulesList.querySelectorAll('.rule-row')).map(row => ({
            id: row.dataset.ruleId,
            field: row.querySelector('[data-prop="field"]').value,
            operator: row.querySelector('[data-prop="operator"]').value,
            value: row.querySelector('[data-prop="value"]').value,
        }));
    }

    setValue(rules) {
        this.rules = Array.isArray(rules) ? rules : [];
        this.renderRules();
    }
}